import React from 'react';
import Breadcrumb from '../common/Breadcrumb';
import Footer from '../common/Footer';
import Header from '../common/Header';
import { Helmet } from 'react-helmet';

function About() {
  return (
    <div>
      <Helmet>
        <title>About Us – Dr. Neha Thukral | Swakaaya Wellness Clinic</title>
        <meta
          name='description'
          content='Discover Swakaaya Wellness Clinic in Gurgaon led by Dr. Neha Thukral. We offer holistic wellness, advanced treatments, and personalized care for your health.'
        />
        <meta
          name='keywords'
          content='Swakaaya Wellness Clinic Gurgaon, Dr. Neha Thukral, wellness clinic Gurgaon, holistic wellness Gurgaon, personalized care, health and wellness clinic Gurgaon'
        />
        <link rel='canonical' href='https://swakaaya.com/about-us' />

        <meta
          property='og:title'
          content='About Us – Dr. Neha Thukral | Swakaaya Wellness Clinic'
        />
        <meta
          property='og:description'
          content='Discover Swakaaya Wellness Clinic in Gurgaon led by Dr. Neha Thukral. We offer holistic wellness, advanced treatments, and personalized care for your health.'
        />
        <meta property='og:url' content='https://swakaaya.com/about-us' />
        <meta property='og:type' content='website' />
        <meta
          property='og:image'
          content='https://swakaaya.com/assets/images/logo.png'
        />
        <meta name='twitter:card' content='summary_large_image' />
        <meta
          name='twitter:title'
          content='About Us – Dr. Neha Thukral | Swakaaya Wellness Clinic'
        />
        <meta
          name='twitter:description'
          content='Discover Swakaaya Wellness Clinic in Gurgaon led by Dr. Neha Thukral. We offer holistic wellness, advanced treatments, and personalized care for your health.'
        />
        <meta
          name='twitter:image'
          content='https://swakaaya.com/assets/images/logo.png'
        />
      </Helmet>
      <Header />
      <Breadcrumb title={'About us'} />

      <div className='section section-padding about-section'>
        <div className='container'>
          {/* About Wrapper Start */}
          <div className='about-wrapper'>
            <div className='row justify-content-center align-items-center'>
              <div className='col-lg-6 col-md-8'>
                {/* About Image Start */}
                <div
                  className='about-image'
                  data-aos='fade-right'
                  data-aos-delay={200}
                >
                  <img
                    src='/assets/images/about.jpg'
                    width={540}
                    height={565}
                    alt='About'
                  />
                </div>
                {/* About Image End */}
              </div>
              <div className='col-lg-6'>
                {/* About Image Start */}
                <div
                  className='about-content'
                  data-aos='fade-left'
                  data-aos-delay={200}
                >
                  {/* Section Title Start */}
                  <div className='section-title'>
                    <h2 className=''>Welcome to Swakaaya Clinic</h2>
                  </div>
                  {/* Section Title End */}

                  <p>
                    <strong>Swakaaya Wellness Clinic</strong> is based in Delhi
                    & Gurugram and has been founded by Dr. Neha Thukral in the
                    year 2019 with the intention of providing quality treatment
                    for all types of skin, hair, and cosmetic concerns. Our
                    flagship services include Hair restoration, Skincare, Body
                    shaping, Anti-aging, and Aesthetic surgery.
                  </p>
                  <p>
                    Our team understands how distressing hair loss, acne, and
                    belly fat can be. Whether patients are hoping to have
                    cosmetic treatment or to treat a condition, our experts will
                    provide them with the best possible treatment available.
                    Clients of all ages are welcome at the Swakaaya Wellness
                    Clinic for skin, hair & body care. We tailor our services to
                    every customer, considering their skin type, budget, and
                    requirements.
                  </p>
                  <p>
                    With thousands of clients in our database, we are committed
                    to delivering the highest quality care by using the most
                    advanced methods and technologies in the research,
                    diagnosis, and treatment of skin disorders.
                  </p>
                  <div className='proud'>
                    <h5>
                      WE ARE PROUD TO HAVE RENOWNED DERMATOLOGISTS AND COSMETIC
                      SURGEONS WITH 15 YEARS OF EXPERIENCE.
                    </h5>
                  </div>
                </div>
                {/* About Image End */}
              </div>
            </div>
          </div>
          {/* About Wrapper End */}
        </div>
      </div>
      <section className='section section-padding about-section ptb-50'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-5'>
              <div className='doctor-iamge'>
                <img src='/assets/images/neha_image.jpeg' />
              </div>
            </div>
            <div className='col-md-7'>
              <div className='doctor-content'>
                <h2>MEET OUR FOUNDER: DR. NEHA THUKRAL </h2>
                <p className='mb-2'>
                  At the heart of Swakaaya Wellness Clinic is Dr. Neha Thukral,
                  our visionary Founder and Director. A certified cosmetologist,
                  Dr. Thukral brings exceptional expertise and a passion for
                  holistic wellness to every treatment we offer. With years of
                  experience in advanced skin, hair, and wellness therapies, she
                  has built Swakaaya as a sanctuary where science and artistry
                  meet.
                </p>
                <p className='mb-2'>
                  Dr. Thukral’s philosophy is rooted in personalized care;
                  understanding every client’s unique needs to deliver natural,
                  transformative results. Her approach combines the latest
                  technologies with a compassionate touch, ensuring every
                  individual feels confident, rejuvenated, and valued.
                </p>
                <p>
                  Under her leadership, Swakaaya Wellness Clinic has become
                  synonymous with premium care, innovative solutions, and
                  outstanding results. Dr. Neha Thukral continues to inspire her
                  team and clients alike, redefining wellness and beauty
                  standards while making every visit an empowering experience.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <section className="section section-padding about-section">
        <div className="container">
          <div className="row">
            <div className="col-md-7">
              <div className="doctor-content">
                <h2>MEET OUR CO-FOUNDER: DR. RISHI KAPAHI</h2>
                <p>
                  <strong>Dr. Rishi Kapahi,</strong> co-founder of Swakaaya
                  Wellness Clinic and a renowned doctor in New Delhi. Dr. Kapahi
                  enjoys working closely with his patients to create
                  personalized treatment plans aimed to improve, repair, and
                  maintain healthy glowing skin.
                </p>
              </div>
            </div>
            <div className="col-md-5">
              <div className="doctor-iamge">
                <img src="" />
              </div>
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-md-12">
              <div className="help">
                <h4 className="text-center" style={{ fontWeight: 700 }}>
                  We help you to look and feel beautiful. Our motive is to make
                  you feel confident in your body. We are just a call away!
                </h4>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <Footer />
    </div>
  );
}

export default About;
